enum PolicyStatus {
  secondary = "secondary",
  success = "success",
  warning = "warning",
  danger = "danger",
}
export const validateTextTypeString = (
  value?: string
): PolicyStatus | undefined => PolicyStatus[value as keyof typeof PolicyStatus];
